

















































































































































































































































































































































































































































































































































































import Vue from 'vue'
import Component from 'vue-class-component'
import { Prop } from 'vue-property-decorator'
import ConfirmPicklStatus from '../SAdmin/ConfirmPicklStatus.vue'
import TaskSyncLogPopup from '@/components/SAdmin/TaskSyncLogPopup.vue'
import CommonPicklDetails from '@/components/common/PicklDetails.vue'

declare var $: any

@Component({
  components: {
    ConfirmPicklStatus,
    TaskSyncLogPopup,
    CommonPicklDetails
  }
})
export default class PicklDetailsPopup extends Vue {
  @Prop() popupId!: string
  @Prop() pickl!: any
  @Prop({ default: false }) brand!: boolean

  public sharedLinkGenerated: boolean = false
  public sharedLink: string = ''
  public confirmationType: string = 'approve'
  public changingStatus: boolean = false
  public rating: number = 0
  public hoverRating: number = 0
  public adminNote: string = ''
  public needReview: boolean = false
  public showNotesToBrand: number = 1
  public surveyQuestionCollapsed: Record<string, boolean> = {}
  public lowSrcQuery: string = '?w=200&q=80&h=200&fit=crop'
  public viewerOptions: any = {
    toolbar: {
      zoomIn: 1,
      zoomOut: 1,
      oneToOne: 0,
      reset: 0,
      prev: {
        size: 'large'
      },
      play: 0,
      next: {
        size: 'large'
      },
      rotateLeft: 1,
      rotateRight: 1,
      flipHorizontal: 0,
      flipVertical: 0
    },
    filter: (image: any) => {
      return !image.src.endsWith('/img/Alerts/timeGreen_icon.png')
    },
    title: [
      1,
      (image: any, imageData: any) => {
        return image.alt
      }
    ],
    url: (image: any) => {
      return image.src.replace(this.lowSrcQuery, '')
    }
  }

  get isMixCampaign (): boolean {
    if (!this.pickl) return false
    const value = this.pickl.mix_campaign
    return value === true || value === 1 || value === '1'
  }

  get isBrand (): boolean {
    return this.brand
  }

  get workflowTabs () {
    if (!this.pickl || !this.pickl.workflow) {
      return []
    }

    const workflow = this.pickl.workflow
    const tabs: any[] = []

    // Process Product activities (array)
    if (workflow.product && Array.isArray(workflow.product) && workflow.product.length > 0) {
      tabs.push({
        type: 'product',
        label: 'Specific Pics',
        order: 1,
        data: workflow.product
      })
    }

    // Process Selfie activity (object)
    if (workflow.selfie && typeof workflow.selfie === 'object') {
      tabs.push({
        type: 'selfie',
        label: workflow.selfie.label || 'Selfie',
        order: workflow.selfie.order || tabs.length + 1,
        data: workflow.selfie
      })
    }

    // Process Video activity (object)
    if (workflow.video && typeof workflow.video === 'object') {
      tabs.push({
        type: 'video',
        label: workflow.video.label || 'Video',
        order: workflow.video.order || tabs.length + 1,
        data: workflow.video
      })
    }

    // Process Survey activities (array or single object)
    if (workflow.survey) {
      if (Array.isArray(workflow.survey) && workflow.survey.length > 0) {
        tabs.push({
          type: 'survey',
          label: 'Survey',
          order: tabs.length + 1,
          data: workflow.survey
        })
      } else if (typeof workflow.survey === 'object' && workflow.survey !== null && !Array.isArray(workflow.survey)) {
        tabs.push({
          type: 'survey',
          label: (workflow.survey as any).label || 'Survey',
          order: (workflow.survey as any).order != null ? (workflow.survey as any).order : tabs.length + 1,
          data: [workflow.survey]
        })
      }
    }

    // Process other activity types (buy-me, deal-drop, watch, watch-video, url-visit, app-install, review, etc.)
    const otherActivityTypes = ['buy-me', 'deal-drop', 'watch', 'watch-video', 'url-visit', 'app-install', 'review', 'photo', 'media']
    const addedTypes = new Set(tabs.map((t: any) => t.type))
    otherActivityTypes.forEach((activityType) => {
      if (addedTypes.has(activityType)) return
      if (workflow[activityType]) {
        const activityData = workflow[activityType]
        if (typeof activityData === 'object' && activityData !== null) {
          tabs.push({
            type: activityType,
            label: activityData.label || this.getActivityLabel(activityType),
            order: activityData.order != null ? activityData.order : tabs.length + 1,
            data: activityData
          })
          addedTypes.add(activityType)
        }
      }
    })

    // Add any remaining workflow keys we might have missed (so all 5+ activities show)
    Object.keys(workflow).forEach((key) => {
      if (addedTypes.has(key)) return
      const val = workflow[key]
      if (val && typeof val === 'object' && !Array.isArray(val)) {
        const order = (val as any).order != null ? (val as any).order : tabs.length + 1
        tabs.push({
          type: key,
          label: (val as any).label || this.getActivityLabel(key),
          order,
          data: val
        })
        addedTypes.add(key)
      }
    })

    // Sort tabs by order
    return tabs.sort((a, b) => (a.order || 999) - (b.order || 999))
  }

  getSurveyQuestionKey (tabIndex: number, sIndex: number, qIndex: number): string {
    return `survey-${tabIndex}-${sIndex}-${qIndex}`
  }

  isSurveyQuestionCollapsed (tabIndex: number, sIndex: number, qIndex: number): boolean {
    const key = this.getSurveyQuestionKey(tabIndex, sIndex, qIndex)
    return this.surveyQuestionCollapsed[key] !== false
  }

  toggleSurveyQuestion (tabIndex: number, sIndex: number, qIndex: number) {
    const key = this.getSurveyQuestionKey(tabIndex, sIndex, qIndex)
    this.$set(this.surveyQuestionCollapsed, key, !this.surveyQuestionCollapsed[key])
  }

  getSurveyDetails (surveyItem: any): any {
    if (!surveyItem) return null
    return surveyItem.surveyDetails || surveyItem.survey || null
  }

  getSurveyQuestions (surveyItem: any): any[] {
    const details = this.getSurveyDetails(surveyItem)
    if (!details) return []
    const q = details.surveyQuestions || details.survey_questions
    return Array.isArray(q) ? q : []
  }

  getSurveyAnswerOptions (question: any): any[] {
    if (!question) return []
    const opts = question.surveyAnswers || question.survey_question_answers
    return Array.isArray(opts) ? opts : []
  }

  getSurveyUserResponse (surveyItem: any): any[] {
    const list = surveyItem.user_response || surveyItem.userResponse
    return Array.isArray(list) ? list : []
  }

  getSurveyUserAnswerForQuestion (surveyItem: any, questionId: number): any {
    const responses = this.getSurveyUserResponse(surveyItem)
    return responses.find((r: any) => (r.question_id || r.questionId) === questionId) || null
  }

  getSurveyAnswerOptionText (question: any, answerId: number): string {
    const opts = this.getSurveyAnswerOptions(question)
    const opt = opts.find((o: any) => (o.id || o.answerId) === answerId)
    return opt ? (opt.answerOption || opt.answer_option || '') : ''
  }

  isSurveyAnswerSelected (surveyItem: any, questionId: number, answerId: number): boolean {
    const userAnswer = this.getSurveyUserAnswerForQuestion(surveyItem, questionId)
    if (!userAnswer) return false
    return (userAnswer.answer_id || userAnswer.answerId) === answerId
  }

  getSurveyUserAnswerText (surveyItem: any, question: any): string {
    const qId = question.id || question.questionId
    const userAnswer = this.getSurveyUserAnswerForQuestion(surveyItem, qId)
    if (!userAnswer) return ''
    const text = userAnswer.text_answer || userAnswer.textAnswer
    if (text) return text
    const answerId = userAnswer.answer_id || userAnswer.answerId
    return this.getSurveyAnswerOptionText(question, answerId) || ('Answer ID ' + answerId)
  }

  getActivityLabel (type: string): string {
    const labels: any = {
      'buy-me': 'Reimbursement',
      'deal-drop': 'Deal Drop',
      'watch': 'Watch',
      'watch-video': 'Watch Video',
      'url-visit': 'URL Visit',
      'app-install': 'App Install',
      'review': 'Review',
      'photo': 'General Photo',
      'product': 'Specific Photo',
      'media': 'Media',
      'survey': 'Survey'
    }
    return labels[type] || type.charAt(0).toUpperCase() + type.slice(1).replace(/-/g, ' ')
  }

  watchVideoUrl (data: any): string {
    if (!data) return ''
    const url = (data.website_link || data.youtubeUrl || data.url || data.video_url || '').trim()
    if (!url) return ''
    if (/youtube\.com|youtu\.be/i.test(url)) return url
    return ''
  }

  youtubeEmbedSrc (data: any): string {
    return this.getYoutubeEmbedUrl(this.watchVideoUrl(data))
  }

  getYoutubeEmbedUrl (url: string): string {
    if (!url || !url.trim()) return ''
    let videoId = ''
    try {
      if (/youtube\.com\/embed\/([^/?&]+)/i.test(url)) {
        videoId = url.match(/youtube\.com\/embed\/([^/?&]+)/i)![1]
      } else if (/youtube\.com\/watch\?([^#]*&)?v=([^&]+)/i.test(url)) {
        const m = url.match(/[?&]v=([^&]+)/i)
        videoId = m ? m[1] : ''
      } else if (/youtu\.be\/([^/?&]+)/i.test(url)) {
        videoId = url.match(/youtu\.be\/([^/?&]+)/i)![1]
      } else if (/youtube\.com\/v\/([^/?&]+)/i.test(url)) {
        videoId = url.match(/youtube\.com\/v\/([^/?&]+)/i)![1]
      }
      if (videoId) {
        return 'https://www.youtube.com/embed/' + videoId
      }
    } catch (e) {}
    return ''
  }

  getLinkActivityImages (data: any): any[] {
    if (!data) return []
    const list = data.images || data.link_images || (data.link && data.link.images) || []
    return Array.isArray(list) ? list : []
  }

  getLinkImageSrc (img: any): string {
    const url = (img && (img.image || img.url)) || ''
    if (!url) return ''
    return url + (url.indexOf('?') === -1 ? this.lowSrcQuery : '')
  }

  /** Return only actual product entries from activity.data (exclude pickl_campaign_activity_id, user_response, etc.) */
  getProductActivityItems (activity: any): any[] {
    if (!activity || !activity.data) return []
    const data = activity.data
    if (Array.isArray(data)) return data
    const skipKeys = new Set(['pickl_campaign_activity_id', 'user_response', 'order', 'label', 'activity'])
    return Object.keys(data)
      .filter((key) => !skipKeys.has(key))
      .filter((key) => {
        const val = data[key]
        return val && typeof val === 'object' && (val.product != null || val.product_id != null)
      })
      .map((key) => data[key])
  }

  getActivityUserResponses (activity: any): any[] {
    if (!activity || !activity.data) return []
    const list = activity.data.user_response
    if (list && Array.isArray(list)) return list
    if (activity.type === 'photo') {
      const activityId = activity.data.pickl_campaign_activity_id
      const photos = this.pickl && this.pickl.user_pickl && this.pickl.user_pickl.user_pickl_photos
      if (!photos || !Array.isArray(photos)) return []
      const filtered = activityId != null ? photos.filter((p: any) => p.pickl_campaign_activity_id === activityId) : []
      return filtered.length > 0 ? filtered : photos
    }
    return []
  }

  getPhotoActivityTasks (activity: any): any[] {
    if (!activity || !activity.data) return []
    const data = activity.data
    const slots: any[] = []
    Object.keys(data).forEach((key) => {
      if (key === 'pickl_campaign_activity_id') return
      const num = Number(key)
      if (!Number.isNaN(num) && data[key] && data[key].task) {
        slots.push({ ...data[key], _order: num })
      }
    })
    return slots.sort((a, b) => (a._order || 0) - (b._order || 0))
  }

  getPhotoTaskImageUrl (task: any): string {
    if (!task) return ''
    const url = task.image || ''
    if (!url) return ''
    const fullUrl = (url.startsWith('http://') || url.startsWith('https://')) ? url : (process.env.VUE_APP_ASSETS_URL || '') + '/task_images/' + (task.id || '') + '/' + url
    return fullUrl + (fullUrl.indexOf('?') === -1 ? this.lowSrcQuery : '')
  }

  getUserResponseImageUrl (resp: any, activityType: string): string {
    if (!resp || !resp.image) return ''
    const img = typeof resp.image === 'string' ? resp.image : ''
    if (!img) return ''
    if (img.startsWith('http://') || img.startsWith('https://')) {
      return img + (img.indexOf('?') === -1 ? this.lowSrcQuery : '')
    }
    let base = process.env.VUE_APP_ASSETS_URL || ''
    if (!base && this.pickl) {
      const selfieImg = this.pickl.user_pickl_selfie && this.pickl.user_pickl_selfie.image
      const photoImg = this.pickl.user_pickl && this.pickl.user_pickl.user_pickl_photos && this.pickl.user_pickl.user_pickl_photos[0] && this.pickl.user_pickl.user_pickl_photos[0].image
      const sample = selfieImg || photoImg
      if (typeof sample === 'string' && (sample.startsWith('http://') || sample.startsWith('https://'))) {
        base = sample.split('/').slice(0, 3).join('/')
      }
    }
    const path = activityType === 'selfie' ? 'user_pickl_selfies' : 'user_pickl_images'
    const userPicklId = this.pickl && this.pickl.user_pickl && this.pickl.user_pickl.id
    const prefix = userPicklId && activityType !== 'selfie' ? `${path}/${userPicklId}/` : `${path}/`
    const fullUrl = (base ? base + '/' : '') + prefix + img
    return fullUrl + (fullUrl.indexOf('?') === -1 ? this.lowSrcQuery : '')
  }

  formatResponseDate (dateStr: string): string {
    if (!dateStr) return ''
    try {
      const d = new Date(dateStr)
      return isNaN(d.getTime()) ? dateStr : d.toLocaleString()
    } catch (e) {
      return dateStr
    }
  }

  formatSummaryDate (dateStr: string): string {
    if (!dateStr) return ''
    try {
      const d = new Date(dateStr)
      return isNaN(d.getTime()) ? dateStr : d.toLocaleDateString(undefined, { day: 'numeric', month: 'short', year: 'numeric' })
    } catch (e) {
      return dateStr
    }
  }

  getStoreName (pickl: any): string {
    if (!pickl) return 'Do Task Anywhere'
    const store = pickl.store || (pickl.store_location && pickl.store_location.store)
    return (store && store.name) ? store.name : 'Do Task Anywhere'
  }

  getStoreImage (pickl: any): string {
    if (!pickl) return ''
    const store = pickl.store || (pickl.store_location && pickl.store_location.store)
    return (store && store.image) ? store.image : ''
  }

  formatStoreLocationAddress (loc: any): string {
    if (!loc) return ''
    const parts: string[] = []
    if (loc.address) parts.push(loc.address)
    const cityStateZip = [loc.city, loc.state, loc.zip_code].filter(Boolean).join(', ')
    if (cityStateZip) parts.push(cityStateZip)
    return parts.join(' · ')
  }

  getReimbursementCredits (pickl: any): number | null {
    if (!pickl) return null
    let val = pickl.reimbursement_credits != null ? pickl.reimbursement_credits : pickl.reimbursementCredits
    if (val == null && pickl.user_pickl) {
      val = pickl.user_pickl.reimbursement_credits != null ? pickl.user_pickl.reimbursement_credits : pickl.user_pickl.reimbursementCredits
    }
    return val != null && val !== '' ? Number(val) : null
  }

  formatCreditsDisplay (pickl: any): string {
    const credits = pickl && pickl.credits != null && pickl.credits !== '' ? Number(pickl.credits) : null
    const reimbursement = this.getReimbursementCredits(pickl)
    if (credits != null && reimbursement != null && reimbursement > 0) {
      return `$${credits} + $${reimbursement}`
    }
    if (credits != null) return `$${credits}`
    if (reimbursement != null) return `$${reimbursement}`
    return '—'
  }

  formatPicklrMobile (user: any): string {
    if (!user) return ''
    const parts = [user.country_code, user.mobile_number].filter(Boolean)
    return parts.join(' ').trim() || ''
  }

  redirectToPicklsPage () {
    this.$emit('statusUpdated')
  }

  getPicklDetails () {
    this.$emit('updatePicklDetails')
  }

  generateShareLink () {
    const payload = {}
    this.$http.post(`brand_shared_pickls/${this.pickl.brand_id}/${this.pickl.id}`, payload).then((response: any) => {
      if (response.body.status === true) {
        this.sharedLinkGenerated = true
        this.sharedLink = process.env.VUE_APP_URL + '/overview/' + response.body.data.code
      }
    })
  }

  getImagePath (i: number): string {
    if (this.hoverRating > 0) {
      return i <= this.hoverRating ? '/img/Alerts/starActive_icon.png' : '/img/Alerts/star_icon.png'
    }
    return i <= this.rating ? '/img/Alerts/starActive_icon.png' : '/img/Alerts/star_icon.png'
  }

  approvePickl () {
    if (this.rating === 0) {
      this.$notify({ text: 'Please select rating for this pickl.', type: 'error' })
      return
    }
    if (this.adminNote.length > 120) {
      this.$notify({ text: 'Notes should not be more than 120 characters.', type: 'error' })
      return
    }
    this.confirmationType = 'approve'
    const trigger = this.$refs.openConfirmModalTrigger as HTMLElement
    if (trigger) {
      trigger.click()
    } else if (typeof $ !== 'undefined') {
      const el = this.$refs.approvedPicklPopup as any
      if (el && el.$el) {
        $(el.$el).modal('show')
      }
    }
  }

  rejectPickl () {
    if (!this.adminNote || this.adminNote.trim() === '') {
      this.$notify({ text: 'Please enter reason of rejection.', type: 'error' })
      return
    }
    if (this.adminNote.length > 120) {
      this.$notify({ text: 'Notes should not be more than 120 characters.', type: 'error' })
      return
    }
    const data = {
      admin_rating: this.rating,
      admin_note: this.adminNote,
      need_review: this.needReview ? 'Yes' : 'No',
      show_notes_to_brand: this.showNotesToBrand
    }
    this.$http.patch(`user_pickls/${this.pickl.user_pickl.id}/REJECTED`, data).then(
      () => {
        this.$notify({ type: 'success', text: 'Pickl has been rejected successfully!' })
        this.$emit('statusUpdated')
      },
      () => {
        this.$notify({ type: 'error', text: 'Failed to save pickl status' })
      }
    )
  }

  confirmed (type: string) {
    if (type === 'approve') {
      this.confirmApprove()
    } else {
      this.$emit('updatePicklsCount')
    }
  }

  confirmApprove () {
    this.changingStatus = true
    const data = {
      admin_rating: this.rating,
      admin_note: this.adminNote,
      need_review: this.needReview ? 'Yes' : 'No',
      show_notes_to_brand: this.showNotesToBrand
    }
    this.$http.patch(`user_pickls/${this.pickl.user_pickl.id}/APPROVED`, data).then(
      () => {
        this.$notify({ type: 'success', text: 'Pickl has been approved successfully!' })
        this.$emit('statusUpdated')
        this.changingStatus = false
      },
      () => {
        this.$notify({ type: 'error', text: 'Failed to save pickl status' })
        this.changingStatus = false
      }
    )
  }

  reverseRejectPickl () {
    const data = {
      admin_rating: this.rating,
      admin_note: this.adminNote,
      need_review: this.needReview ? 'Yes' : 'No'
    }
    this.$http.patch(`user_pickls/${this.pickl.user_pickl.id}/REVERSE_REJECTED`, data).then(
      () => {
        this.$notify({ type: 'success', text: 'Pickl rejection has been reversed successfully!' })
        this.$emit('statusUpdated')
      },
      () => {
        this.$notify({ type: 'error', text: 'Failed to save pickl status' })
      }
    )
  }
}
